export default __webpack_public_path__ + "static/Guides_3-b2e6b2d8e78a149fe89bfa8fdb6dc4cf.jpg";